module.exports = __webpack_public_path__ + "img/sy.93007050.svg";